// Regex constant for URL protocol validation
const PROTOCOL_REGEX = /^https?:\/\//i

export function getValidUrl(url: string | null | undefined): string {
  if (!url) {
    return ""
  }

  let processedUrl = url.trim()
  // Prepend 'https://' if the URL does not start with any protocol
  if (!PROTOCOL_REGEX.test(processedUrl)) {
    processedUrl = `https://${processedUrl}`
  }

  try {
    const validUrl = new URL(processedUrl)
    // Since we prepend 'https://' for URLs without a protocol,
    // and the regex ensures it starts with http or https,
    // we only need to check protocols we accept
    if (validUrl.protocol !== "http:" && validUrl.protocol !== "https:") {
      return "about:blank#blocked"
    }
    return validUrl.href // Use href to ensure we get the normalized URL
  } catch {
    return "about:blank#blocked"
  }
}

/**
 * NOTE: This is important to keep in sync with the current app's
 * top level paths in order for vanity urls to not break those paths.
 * should we derive this from the filesystem instead?
 */

export enum TopLevelPath {
  activity = "/activity",
  chat = "/chat",
  careers = "/careers",
  contract = "/contract",
  create = "/create",
  geoUnavailable = "/geo-unavailable",
  item = "/item",
  privacy = "/privacy",
  profileSettings = "/profile-settings",
  stats = "/stats",
  tos = "/tos",
  rewards = "/rewards",
  collection = "/collection",
  discover = "/discover",
  profile = "/profile",
  verifyEmail = "/verify-email",
  oauth = "/oauth",
  onboard = "/onboard",
  token = "/token",
  gallery = "/gallery",
  settings = "/settings",
  developerTerms = "/developer-terms",
  opengraph = "/opengraph-image",
  studio = "/studio",
  drops = "/drops",
  treasure = "/treasure",
  swap = "/swap",
}

export const isTopLevelPath = (path: string) => {
  return Object.values(TopLevelPath).some(p => path.startsWith(p))
}
